import {AfterViewInit, Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {QuotationService} from '../../services/quotation-service/quotation.service';
import {InsureStep} from '../insureStep';
import {Router} from '@angular/router';
import {QuotationStep} from '../../model/QuotationStep';
import {VehicleUsage} from '../../model/VehicleUsage';
import {ParkingSecurity} from '../../model/ParkingSecurity';
import {LeadService} from '../../services/lead-service/lead.service';
import {WebLeadType} from '../../model/leads/WebLeadType';
import {ValidationService} from '../../services/validation-service/validation.service';
import {VehicleDetails} from '../../model/VehicleDetails';
import {Address} from '../../model/Address';
import {BehaviorSubject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {isNullOrUndefined} from 'util';
import {ErrorCodes} from '../../model/ErrorCodes';
import {TransUnionEnquiryList} from '../../model/quotes/TransUnionEnquiryList';
import {ContentComponent} from '../content/content.component';
import {ErrorMessages} from '../../model/ErrorMessages';
import {environment} from '../../../environments/environment';
import {CampaignTrackingService} from "../../services/campaign-tracking/campaign-tracking.service";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {GoogleAnalyticsService} from "google-analytics";

declare var $;

@Component({
  selector: 'app-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss']
})
export class StepOneComponent extends InsureStep implements OnInit, AfterViewInit {

  public vehicleUsage = VehicleUsage;
  public parkingSecurity = ParkingSecurity;
  public errorMessage = ErrorMessages;
  public searchTerm: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public addressList: BehaviorSubject<Address[]> = new BehaviorSubject<Address[]>([]);
  public searched = false;
  public loading: boolean;
  public contentID = '';
  public contentReg = '';
  public contentVehicle = '';
  public continueMessage = '';
  private _showCancelModal = false;
  private _showContinueButton = true;
  private facebookReference = false;
  urlHasLeadRef = false;

  constructor(router: Router,
              public quotationService: QuotationService,
              public validationService: ValidationService,
              private leadService: LeadService,
              private contentComponent: ContentComponent,
              private campaignTrackingService: CampaignTrackingService,
              private modalService: NgbModal,
              private googleAnalyticsService: GoogleAnalyticsService,) {
    super(router, quotationService);

    if (this.quotationService.getRetries() === 0) {
      this.quotationService.error = true;
    }
  }

  get showContinueButton(): boolean {
    return this._showContinueButton;
  }

  set showContinueButton(value: boolean) {
    this._showContinueButton = value;
  }

  get showCancelModal(): boolean {
    return this._showCancelModal;
  }

  set showCancelModal(value: boolean) {
    this._showCancelModal = value;
  }

  cancelSelection() {
    this.showCancelModal = false;
    this.quotationService.quotationRequest.vehicleUsage = VehicleUsage.SELECT_USAGE;
  }

  cancelQuoteStep1() {
    this.showCancelModal = false;
    this.quotationService.quotationStep = QuotationStep.LANDING;
    const commercialUsageServce = this.leadService.commercialUsage();
    if (commercialUsageServce) {
      commercialUsageServce.subscribe(
        response => {
          this.router.navigateByUrl('choose-insurance-quote');
        }, error => {
          this.quotationService.error = true;
        });
    } else {
      this.router.navigateByUrl('choose-insurance-quote');
    }
  }

  changeVehicleUsage(vehicleUsage: VehicleUsage) {
    if (vehicleUsage === VehicleUsage.COMMERCIAL) {
      this.showCancelModal = true;
      this.quotationService.scrollToTop();

      this.quotationService.quotationRequest.vehicleUsage = null;
    } else {
      this.quotationService.quotationRequest.vehicleUsage = vehicleUsage;
    }
  }

  getContentError(errorCode: string) {
    return this.contentComponent.customGetContent(environment.errorContentUrl + errorCode);
  }

  continueToStep2() {

    this.validationService.clearErrors();
    if (this.validationService.isStepOneValid()) {
      // Handle the changing of loading text
      if (this.leadService.doesUserHaveProduct === true) {
        this.showContinueButton = false;
        return;
      }

      this.continueMessage = 'Connecting to the credit bureau... ';
      setTimeout(() => {
        this.continueMessage = 'Confirming your vehicle details … ';
      }, 5000);

      // Send GA the lead reference
      let user = {
        'first_name': this.quotationService.quotationRequest.name,
        'last_name': this.quotationService.quotationRequest.surname,
        'email': this.quotationService.quotationRequest.email,
        'phone': this.quotationService.quotationRequest.cellphone.replace(this.quotationService.quotationRequest.cellphone.charAt(0), '+27')
      }
      if (this.leadService.createLeadResponse && this.leadService.createLeadResponse.leadReferenceNumber) {
        this.googleAnalyticsService.postGaEvent(
          'form_step_complete',
          {
            'form_name': 'insure_quote_tool',
            'form_action': 'submit_personal_details',
            'form_step': 2,
            'lead_id': this.leadService.createLeadResponse.leadReferenceNumber.valueOf()
          }
        );
        this.googleAnalyticsService.postGaEvent(
          'generate_lead',
          {
            'form_name': 'insure_quote_tool',
            'form_action': '',
            'form_step': 1,
            'lead_id': this.leadService.createLeadResponse.leadReferenceNumber.valueOf()
          },
          user
        );
      }
      if (this.urlHasLeadRef){
        this.googleAnalyticsService.postGaEvent(
          'form_step_complete',
         {
            'form_name': 'insure_quote_tool',
            'form_action': 'submit_personal_details',
            'form_step': 2,
            'lead_id': +localStorage.getItem('leadReferenceNumbers')
          }
        );
        this.googleAnalyticsService.postGaEvent(
          'generate_lead',
          {
            'form_name': 'insure_quote_tool',
            'form_action': '',
            'form_step': 1,
            'lead_id': +localStorage.getItem('leadReferenceNumbers')
          },
          user
        );
      }

      // If ninja failed then cannot continue the journey
      if (this.leadService.updateLead(WebLeadType.WEB_LEAD_3) === null) {
        this.quotationService.error = true;
        this.quotationService.errorMessage = 'A technical error has occurred. Please try again later.';
      }

      this.quotationService.quotationRequest.medium = '60 second quote';
      this.quotationService.quotationRequest.medium = this.facebookReference? this.quotationService.quotationRequest.medium.concat(' - FACEBOOK') : this.quotationService.quotationRequest.medium;
      if(localStorage.getItem('urlHasLeadReference') === 'true'){
        this.quotationService.quotationRequest.medium = 'MOBILE';
      }
      // Update web_lead to a web_lead 3
      this.leadService.updateLead(WebLeadType.WEB_LEAD_3, null, null, null, this.quotationService.quotationRequest.campaign, this.quotationService.quotationRequest.medium).subscribe(result => {
        },
        error1 => {
          if (error1['error'].toLowerCase().indexOf('active')) {
            this.leadService.doesUserHaveProduct = true;
            this.showContinueButton = false;
          }
        });

      this.loading = true;
      // Continue with request even if timed out
      this.quotationService.requestVehicleDetails().subscribe((response) => {
        this.loading = false;

        // If there is an error 6 or 7 then assign the TU list and direct to step 2 alt
        this.quotationService.quotationRequest.transUnionEnquiryList = new TransUnionEnquiryList();
        this.quotationService.quotationRequest.transUnionEnquiryList.transUnionEnquiry
          = response['transUnionEnquiryList']['transUnionEnquiry'];

        if (response['serviceError'] && response['serviceError'][0] && response['serviceError'][0]['code']) {
          this.getContentError(response['serviceError'][0]['code'].toString()).subscribe((result) => {
            this.quotationService.errorMessage = result;
            this.quotationService.errorCode = response['serviceError'][0]['code'].toString();

            // Update the lead that manual capture had to take place
            if (this.leadService.updateLead(WebLeadType.WEB_LEAD_3)) {
              this.leadService.updateLead(WebLeadType.WEB_LEAD_3, null, null,
                this.quotationService.errorCode + ':' + this.quotationService.errorMessage.replace(/\n/g, ''), this.quotationService.quotationRequest.campaign, this.quotationService.quotationRequest.medium)
                .subscribe((leadUpdateResult) => {
                }, error1 => {
                  this.quotationService.setFallbackError();
                });
            }

            if (this.quotationService.errorCode === '6') {
              this.quotationService.licenseFound = true;
            }
            this.goToStep('Step 2-alt');
          }, error => {
            this.quotationService.setFallbackError();
          });
          return;
        } else {
          this.quotationService.quotationRequest.vehicleDetails = <VehicleDetails>response['vehicleDetails'];
          this.quotationService.quotationRequest.parkingAddress.suburbCd = response['vehicleDetails']['suburbCd'];

          this.goToStep('Step 2');
        }
      }, error1 => {
        // Check if timeout occurred
        if (this.quotationService.parseError(error1)) {
          return;
        }

        // Fetch the correct error content fragment
        this.getContentError(this.quotationService.errorCode)
          .subscribe((response) => {
            this.quotationService.getErrorList().subscribe((errorListString: string[]) => {

              this.quotationService.errorMessage = response;

              if (errorListString.toString().indexOf(this.quotationService.errorCode.toString()) !== -1 ||
                this.quotationService.errorCode === '99') {
                this.quotationService.quotationStep = QuotationStep.STEP_2_ALT;
                this.quotationService.error = false;
                if (this.quotationService.errorCode.toString() === '6') {
                  this.quotationService.licenseFound = true;
                }
                // update lead with error
                if (this.leadService.updateLead(WebLeadType.WEB_LEAD_3)) {
                  this.leadService.updateLead(WebLeadType.WEB_LEAD_3, null, null,
                    this.quotationService.errorCode + ':' + this.quotationService.errorMessage.replace(/\n/g, ''),
                    this.quotationService.quotationRequest.campaign, this.quotationService.quotationRequest.medium)
                    .subscribe((leadUpdateResult) => {
                    }, leadUpdateError => {
                      this.quotationService.setFallbackError();
                    });
                }

                this.quotationService.quotationStep = QuotationStep.STEP_2_ALT;
                this.quotationService.error = false;
              } else {
                this.quotationService.error = true;
              }
            });
          }, contentError => {
            this.quotationService.error = true;
          });
      });
    }
  }

  public addressAutocomplete(phrase: string): void {

    if (phrase.length >= 4) {
      // clean any special chars from the input
      phrase = phrase.replace(/[^a-zA-Z\-\'\s\,]/g, '');

      this.quotationService.quotationRequest.parkingAddress.addressDescr = phrase;
      phrase = phrase.trim();
      this.quotationService.addressRequest.address = phrase;
      this.quotationService.getAddressList().subscribe((addressList: Address[]) => {
        this.searched = true;
        this.addressList.next(addressList);
      }, error1 => {
        this.quotationService.error = true;
      });
    }
  }

  public selectAddress(address: Address) {
    if (!isNullOrUndefined(address)) {
      this.quotationService.quotationRequest.parkingAddress = address;
      this.validationService.addressCheckValue = address.addressDescr;
    }
    this.addressList.next([]);
  }

  ngOnInit() {
    this.quotationService.quotationRequest.isConsentGiven = false;
    this.facebookReference = localStorage.getItem('urlHasFacebookReference') === 'true';
    this.validationService.retrievedLoggedInUser();
    this.searchTerm.pipe(debounceTime(500),
      distinctUntilChanged())
      .subscribe(term => {
        this.addressAutocomplete(term);
      });
    this.quotationService.getTimeoutTime().subscribe((timeOut: number) => {
      this.quotationService.timeout = timeOut;
    }, error1 => {
      this.quotationService.error = true;
    });
    if(localStorage.getItem('urlHasLeadReference') === 'true'){
      this.urlHasLeadRef = true;
    }
  }

  inputChange(value: any) {
    this.searchTerm.next(value);
  }

  ngAfterViewInit(): void {
    this.contentComponent.customGetContent('/discoverycoza/fragments/car-and-home-insurance/quotes/step1-vehicle-usage-tool-tip')
      .subscribe((result) => {
        this.contentVehicle = result;
      });
    this.contentComponent.customGetContent('/discoverycoza/fragments/car-and-home-insurance/quotes/step1-id-number-tool-tip')
      .subscribe((result) => {
        this.contentID = result;
      });
    this.contentComponent.customGetContent('/discoverycoza/fragments/car-and-home-insurance/quotes/step1-license-plate-tool-tip')
      .subscribe((result) => {
        this.contentReg = result;
      });
  }

  isUserLoggedIn() {
    return this.validationService.loggedIn;
  }

  cancelQuote() {
    this.showCancelModal = false;
    this.quotationService.quotationStep = QuotationStep.LANDING;
    this.router.navigateByUrl('choose-insurance-quote');
  }
}
